import { Theme } from './Theme'

export const yes_no_outcome = {
    "Y": "Pass",
    "N": "Fail",
}

export const template_key = {
    "SWV_JA": "SWV - Job Applicant",
    "SWV_SPONSOR": "SWV - Sponsor",
    "SWV_SPONSOR_JOB": "SWV - Sponsor (Job only)",
    "STU_SPONSOR": "Student - Sponsor",
    "STU_APPLICANT": "Student - Applicant",
    "DEP_CHILD": "Dependant Child",
    "DEP_PARTNER": "Dependant Partner",
    "NAT": "Naturalisation",
    "TEST": "Testing",
}

export const case_type = {
    "NATIONALITY": "Nationality",
    "SWV_EC": "SWV - Entry Clearance",
    "SWV_SWITCH": "SWV - Switching Category",
    "SWV_CHANGE": "SWV - Change of Employment",
    "SWV_EXTEND": "SWV - Extension",
    "GBM_EC": "GBM - Entry Clearance",
    "GBM_EXTEND": "GBM - Extension",
    "DEP": "Dependants",
    "ILR": "ILR",
    "OTHER": "Other",
}

export const case_target_date_description = {
    "current_visa_end_date": "Current visa end date",
    "job_start_date": "Job start date"
}

export const case_status_color = {
    "OPENED": Theme.palette.info.light, 
    "QUESTIONNAIRE": Theme.palette.info.light, 
    "ASSESSMENT": Theme.palette.info.light, 
    "APPLICATION": Theme.palette.info.light, 
    "SUBMITTED": Theme.palette.warning.light, 
    "COMPLETED": Theme.palette.success.light,
    "CLOSED": Theme.palette.success.light,
}

export const application_status = {
    "CREATED": "Started",
    "SUBMITTED": "Submitted",
    "CLOSED": "Closed",
}

export const dict_key = {
    "accountName": "Account",
    "account": "Account",
    "sponsor": "Sponsor",
    "subject": "Subject",
    "case": "Case",
    "enquiryUid": "Assessment",
    "parentAccount": "Parent account",
    "parent": "Parent",
    "label": "Label",
    "displayName": "Name",
    "accountType": "Account type",
    "customerType": "Customer type",
    "organisationType": "Organisation type",
    "addressLine1": "Address line 1",
    "city": "City",
    "postcode": "Postcode",
    "phone": "Phone",
    "email": "Email",
    "countryId": "Country ID",
    "status": "Status",
    "regulator": "Regulator",
    "regulatorRegistrationNumber": "Regulator registration number",
    "lastActive": "Last active",
    "createdOn": "Created on",
    "createdBy": "Created by",
    "advisorEmail": "User",
    "notificationEmail": "Creator email",
    "owner": "Owner",
    "details": "Details",
    "uid": "UID",
    "percentageComplete": "Progress",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "lastUpdated": "Updated",
    "deletedAt": "Deleted",
    "case_ref_num": "Case ref num",
    "priority": "Priority",
    "business_owner": "Business owner",
    "subjectNames": "Subjects",
    "users": "Users",
    "user": "User", 
    "questionnaires": "Questionnaires",
    "enquiries": "Enquiries",
    "advisor": "Adviser",
    "automations": "Automations",
    "automationMapKey": "Automation ID",
    "automationJobUid": "Automation job UID",
    "application": "Application",
    "runAt": "Run at",
    "stoppedAt": "Stopped at",
    "requestedAt": "Requested",
    "requestedBy": "User",
    "reportType": "Type",
    "statusId": "Status",
    "template": "Questionnaire type",
    "respondent": "Respondent",
    "sponsorLicenceNum": "Sponsor licence number",
    "sponsorExpiryDate": "Sponsor expiry date",
    "sponsorStartDate": "Sponsor start date",
    "nextTargetDate": "Next target date",
    "finalTargetDate": "Final target date",
}

// subject_country_of_birth contains country names from different time prediods.
// As a result there are duplicate country codes which have been prefixed with '*' so that they may be
// included in the dict. On submit the '*' must be removed.
export const countries_of_birth = {
    "AF": "Afghanistan",
    "AX": "Aland Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "AN.BQ": "Bonaire, Sint Eustatius and Saba",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "VG": "Virgin Islands, British",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CD": "Congo, Democratic Republic of the",
    "CG": "Congo",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote D'Ivoire (Ivory Coast)",
    "HR": "Croatia",
    "CU": "Cuba",
    "AN.CU": "Curaçao",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "SZ": "Swaziland",
    "ET": "Ethiopia",
    "FK": "Falkland Islands",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "UK-GSY": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "UK.IOM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "UK-JSY": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, North (Democratic People's Republic of)",
    "KR": "Korea, South (Republic of Korea)",
    "CS.KO": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macau",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia (Federated States of)",
    "MD": "Moldova (the Republic of)",
    "MC": "Monaco",
    "MN": "Mongolia",
    "CS.MN": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MK": "North Macedonia",
    "CY.N": "Cyprus, northern",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestinian Territory Occupied",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "BL": "Saint Barthélemy",
    "SH": "Saint Helena, Ascension and Tristan da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "São Tomé and Príncipe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "CS.SE": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "AN.SM": "Sint Maarten (Dutch part)",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "SD.S": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen Islands",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syria Arab Republic",
    "TW": "Taiwan",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "VI": "Virgin Islands, U.S.",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "UK": "United Kingdom of Great Britain and Northern Ireland",
    "UK.ENG": "England",
    "UK.SCT": "Scotland",
    "UK.WLS": "Wales",
    "UM": "United States Minor Outlying Islands",
    "US": "United States of America",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",


    "DY": "Dahomey",
    "AN": "Netherlands Antilles",
    "*MM": "Burma",
    "*BY": "Byelorussian SSR",
    "**KI": "Canton and Enderbury Islands",
    "*CZ": "Czechoslovakia",
    "*TL": "Timor-Leste",
    "*FR": "France, Metropolitan",
    "*DJ": "French Afars and Issas",
    "*DE": "German Democratic Republic",
    "*KI": "Gilbert and Ellice Islands",
    "*IQ": "Neutral Zone",
    "*VU": "New Hebrides",
    "*MH": "Pacific Islands (Trust Territory)",
    "*PA": "Panama Canal Zone",
    "*CS": "Serbia and Montenegro",
    "*IN": "Sikkim",
    "*ZW": "Southern Rhodesia",
    "*UM": "United States Miscellaneous Pacific Islands",
    "*BF": "Upper Volta",
    "*VN": "Viet-Nam, Democratic Republic of",
    "*YE": "Yemen, Democratic",
    "YUG": "Yugoslavia",
    "CS": "Yugoslavia",
    "*CD": "Zaire",
    "*RU": "USSR"
}
